export default [
  {
    path: '/controllers',
    name: 'controllers',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Контролёры',
    },
    children: [
      {
        path: '',
        name: 'controllers-list',
        props: true,
        component: () => import('@/views/controllers/controllers.vue'),
        meta: {
          title: 'Список',
        },
      },
      {
        path: 'add',
        name: 'controllers-add',
        props: true,
        component: () => import('@/views/controllers/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'controllers-edit',
        props: true,
        component: () => import('@/views/controllers/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
